import { CountryCode } from '~shared/constants';

const valueAddedServiceSessionStorageKey = 'valueAddedServiceMessage';

export namespace CartCommonUtil {
  export function getValueAddedServiceMessageFromSessionStorage(): string[] {
    try {
      return JSON.parse(sessionStorage.getItem(valueAddedServiceSessionStorageKey));
    } catch (error) {
      clearValueAddedServiceMessageFromSessionStorage();
      return null;
    }
  }

  export function saveValueAddedServiceMessageToSessionStorage(message: string) {
    const currentMessages = getValueAddedServiceMessageFromSessionStorage();
    const messageAlreadyExists = currentMessages?.find((currentMessage) => currentMessage === message);
    if (messageAlreadyExists) {
      return;
    }

    sessionStorage.setItem(
      valueAddedServiceSessionStorageKey,
      JSON.stringify(currentMessages ? [message, ...currentMessages] : [message])
    );
  }

  export function clearValueAddedServiceMessageFromSessionStorage() {
    sessionStorage.removeItem(valueAddedServiceSessionStorageKey);
  }

  interface DeliveryDates {
    minDate: Date
    maxDate: Date
    localizedMinDate: string
    localizedMaxDate: string
  }

  export function getExpectedTime(
    minShippingTime: number,
    maxShippingTime: number,
    market: CountryCode,
    dateFormatting?: Intl.DateTimeFormatOptions
  ): DeliveryDates {
    const defaultFormatting = {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    } as Intl.DateTimeFormatOptions
    const placedAt = firstPlacedBusinessDate()
    const minDate = countBusinessDate(placedAt, minShippingTime)
    const maxDate = countBusinessDate(minDate, maxShippingTime - minShippingTime)
    return {
      localizedMinDate: minDate.toLocaleDateString(
        market,
        dateFormatting ?? defaultFormatting
      ),
      localizedMaxDate: maxDate.toLocaleDateString(
        market,
        dateFormatting ?? defaultFormatting
      ),
      minDate,
      maxDate
    }
  }

  function firstPlacedBusinessDate(): Date {
    const today = new Date()
    if (isWeekEndDay(today.getDay())) {
      const nextMonday = new Date()
      nextMonday.setDate(
        nextMonday.getDate() + ((1 + 7 - nextMonday.getDay()) % 7)
      )
      return nextMonday
    } else {
      return today
    }
  }

  function isWeekEndDay(day: number) {
    return day === 6 || day === 0
  }

  function countBusinessDate(date: Date, days: number) {
    let currentDate = new Date(date)
    let daysCounted = 0

    while (daysCounted < days) {
      currentDate.setDate(currentDate.getDate() + 1)
      if (!isWeekEndDay(currentDate.getDay())) {
        daysCounted++
      }
    }

    currentDate.setHours(0, 0, 0, 0)
    return currentDate
  }
}
